export const changeVisibility = (vis) => (dispatch, getState) => {
    dispatch({
        type: "change3",
        payload: vis
    })
};